import { STORAGE_API } from "@/constants/storage";

declare global {
  interface Window {
    PROPWISE_API_BASE?: string;
  }
}

const API_KEY = STORAGE_API.base;

export function getApiBase(): string {
  // 1. localStorage override — devs / QA can point any deployment at any BE
  //    without rebuilding by setting `propwise.api` in DevTools.
  const stored = localStorage.getItem(API_KEY);
  if (stored) return stored.trim().replace(/\/$/, "");
  // 2. Runtime injection — `/propwise-config.js` written by the in-Docker
  //    nginx entrypoint (envsubst at container startup). 404s harmlessly
  //    on Cloudflare Pages where no envsubst step exists.
  if (window.PROPWISE_API_BASE) return window.PROPWISE_API_BASE.trim().replace(/\/$/, "");
  // 3. Build-time bake — Vite reads `import.meta.env.VITE_API_URL` from the
  //    CI environment. This is the production path on Cloudflare Pages,
  //    where the value is sourced from the BE_URL repo var.
  const built = import.meta.env.VITE_API_URL as string | undefined;
  if (built) return built.trim().replace(/\/$/, "");
  // 4. Empty — Vite dev server proxies relative paths to :12345.
  return "";
}

export function setApiBase(url: string): void {
  localStorage.setItem(API_KEY, url.trim());
}

export function resetApiBase(): void {
  localStorage.removeItem(API_KEY);
}
